//components
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { Alert } from "reactstrap";
import CustomSpinner from "../../Spinner/Spinner";

//libraries / actions/ constants/ utils
import { Strings } from "../../../Resources/Strings/i18n";
import { PATHS } from "../../../Constants";
import { OperationStatus, APIResponse } from "../../../Communication/Constants";
import SettingsAction from "../SettingsAction";

class OtpModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spinner: false,
      show: this.props.showVerifyModal,
      otpEntered: "",
      fetchedUserData: "",
      showDashboard: false,
      userid: "-1",
      otpResentSuccessMessageOpen: false,
      errorMessage: "",
      errorCase: false,
      custSpinner: false,
    };

    this.SettingsAction = new SettingsAction();
  }
  componentDidMount() {
    this.OtpInput.focus();
  }

  componentDidUpdate() {
    if (this.state.errorCase || this.state.otpResentSuccessMessageOpen) {
      this.hideTimeout = setTimeout(
        () =>
          this.setState({
            otpResentSuccessMessageOpen: false,
            errorCase: false,
          }),
        5000
      );
    }
  }
  componentWillUnmount() {
    clearTimeout(this.hideTimeout);
  }

  isValidNumber(mobileNumber) {
    return /^\d+$/.test(mobileNumber);
  }
  handleChange = (event) => {
    let otpText = String(event.target.value);

    if (
      (this.isValidNumber(otpText) && otpText.length < 4) ||
      otpText.length === 0
    ) {
      this.setState({
        otpEntered: otpText,
      });
    }
  };
  setCursorPosition = (event) => {
    event.target.setSelectionRange(
      event.target.value.length,
      event.target.value.length
    );
  };
  enterPress_Login = (event) => {
    if (event.charCode === 13) {
      this.proceedToSettings();
    }
  };
  proceedToSettings = () => {
    if (this.state.otpEntered.length === 3) {
      //
      this.setState({ custSpinner: true });
      let requestObj = {
        mobile: this.props.mobileNumber,
        calling_code: this.props.countryCallingCode,
        otp: this.state.otpEntered,
      };
      if (this.props.showEmail) {
        requestObj = {
          email: this.props.email,
          otp: this.state.otpEntered,
        };
      }

      this.SettingsAction.verifyOTP(requestObj, (actionCallback) => {
        if (actionCallback.status === OperationStatus.SUCCESS) {
          this.setState({
            errorMessage: "",
            custSpinner: false,
          });
          this.props.getProfileDetails();
          this.props.history.push(PATHS.SETTINGS);
          this.props.closeOtpModal();
        } else if (
          actionCallback.error.errorCode === APIResponse.MOBILE_ALREADY_EXISTS
        ) {
          this.setState({
            otpResentFailedMessageOpen: true,
            errorCase: true,
            errorMessage: Strings("MOBILE_ALREADY_EXISTS"),
            custSpinner: false,
          });
          this.props.closeOtpModal();
        } else if (
          actionCallback.error.errorCode === APIResponse.INVALID_OTP_IN_SETTING
        ) {
          this.setState({
            otpResentFailedMessageOpen: true,
            errorCase: true,
            errorMessage: Strings("MOBILE_OTP_EXPIRED"),
            custSpinner: false,
          });
        } else if (
          actionCallback.error.errorCode === APIResponse.EMAIL_ALREADY_EXISTS
        ) {
          this.setState({
            otpResentFailedMessageOpen: true,
            errorCase: true,
            errorMessage: Strings("ERROR_EMAIL_ALREADY_EXISTS"),
            custSpinner: false,
          });
          this.props.closeOtpModal();
        } else if (actionCallback.error.errorCode === APIResponse.INVALID_OTP) {
          this.setState({
            otpResentFailedMessageOpen: true,
            errorCase: true,
            errorMessage: Strings("ERROR_INVALID_OTP"),
            custSpinner: false,
          });
        } else if (
          actionCallback.error.errorCode ===
          APIResponse.REQUEST_FIELD_NOT_PRESENT_OR_INVALID
        ) {
          this.setState({
            showCustomModal: false,
            showErrorModal: true,
            errorMessage: Strings("ERROR_FIELD_NOT_PRESENT_OR_INVALID"),
            mobileNumberValue: "",
            callingCode: "+1",
            custSpinner: false,
          });
        } else {
          this.setState({
            errorCase: true,
            errorMessage: actionCallback.error.errorMessage,
            otpEntered: "",
            custSpinner: false,
          });
        }
      });
    } else {
      if (this.state.otpEntered.length === 0) {
        this.setState({
          errorCase: true,
          errorMessage: Strings("OTPCannotBeBlank"),
        });
      } else {
        this.setState({
          errorCase: true,
          errorMessage: Strings("InvalidOTPEntered"),
          otpEntered: "",
        });
      }
    }
  };

  resendOtp = () => {
    this.setState({ otpEntered: "", custSpinner: true });
    let requestObj = {
      mobile: this.props.mobileNumber,
      calling_code: this.props.countryCallingCode,
    };
    if (this.props.showEmail) {
      requestObj = {
        email: this.props.email,
      };
    }
    this.SettingsAction.sendOTP(requestObj, (actionCallback) => {
      if (actionCallback.status === OperationStatus.SUCCESS) {
        this.setState({
          showCustomModal: false,
          errorMessage: "",
          showOTPModal: true,
          otpResentSuccessMessageOpen: true,
          custSpinner: false,
        });
      } //error handling
      else if (
        actionCallback.error.errorCode === APIResponse.MOBILE_ALREADY_EXISTS
      ) {
        this.setState({
          otpResentFailedMessageOpen: true,
          errorCase: true,
          custSpinner: false,
          errorMessage: Strings("MOBILE_ALREADY_EXISTS"),
        });
      } else if (
        actionCallback.error.errorCode === APIResponse.EMAIL_VERIFIED_ALREADY
      ) {
        this.setState({
          otpResentFailedMessageOpen: true,
          errorCase: true,
          custSpinner: false,
          errorMessage: Strings("EMAIL_VERIFIED_ALREADY"),
        });
      } else if (
        actionCallback.error.errorCode ===
        APIResponse.REQUEST_FIELD_NOT_PRESENT_OR_INVALID
      ) {
        this.setState({
          otpResentFailedMessageOpen: true,
          errorCase: true,
          custSpinner: false,
          errorMessage: Strings("ERROR_FIELD_NOT_PRESENT_OR_INVALID"),
        });
      } else {
        this.setState({
          otpResentFailedMessageOpen: true,
          errorCase: true,
          errorMessage: actionCallback.error.errorMessage,
          custSpinner: false,
        });
      }
    });
  };
  renderAlert = () => {
    return (
      <Alert color="danger" className="alertMessage">
        {this.state.errorMessage}
      </Alert>
    );
  };
  render() {
    return (
      <div className="">
        <CustomSpinner showModal={this.state.custSpinner} />
        <div className="verifyOtp">
          <div className="verifyModal">
            <br />
            <div className="modalTitle">
              <p id="verifyTitle">
                <span id="verifiText">{Strings("Verifi")}</span>
                {Strings("cation")}
              </p>
            </div>
            {this.state.errorCase ? this.renderAlert() : null}
            {this.state.otpResentSuccessMessageOpen ? (
              <Alert color="success" className="alertMessage">
                {Strings("OTPResentSuccessFully")}
              </Alert>
            ) : null}
            {this.props.showEmail ? (
              <p className="infoText">{Strings("OTPInfoEmailText")}</p>
            ) : (
              <p className="infoText">{Strings("OTPInfoText")}</p>
            )}
            <br />
            <div className="otpInputContainer">
              <div className="otpInput">
                <input
                  ref={(input) => {
                    this.OtpInput = input;
                  }}
                  className="otpInputText"
                  type="text"
                  maxLength="3"
                  value={this.state.otpEntered}
                  onKeyPress={this.enterPress_Login}
                  onClick={this.setCursorPosition}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <br />
            {this.props.showEmail ? (
              <p className="infoText">
                Sent to (<span id="phoneNoText">{this.props.email}</span>)
              </p>
            ) : (
              <p className="infoText">
                Sent to (
                <span id="phoneNoText">
                  {this.props.countryCallingCode} - {this.props.mobileNumber}
                </span>
                )
              </p>
            )}

            <br />
            <Button className="verifyBtn" onClick={this.proceedToSettings}>
              {Strings("VERIFY")}
            </Button>
            <p className="infoText">{Strings("codeNotReceived1")}</p>
            <Button className="resendBtn" onClick={this.resendOtp}>
              {Strings("resend")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUserInfo: state.currentUserInfo,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

OtpModal.defaultProps = {
  showVerifyModal: false,
  mobileNumber: "",
  countryCallingCode: "",
};

export default withRouter(
  connect(mapStateToProps, matchDispatchToProps)(OtpModal)
);
